import { AxiosResponse } from 'axios'
import { format } from 'date-fns'
import axios from 'src/lib/axios'
import { ActionLog } from 'src/types/actionLog'

export const fetchActionLogs = async (
  agencyCode: string,
  startDate: Date,
  endDate: Date,
  userId?: number,
  route?: string,
  page?: number
): Promise<AxiosResponse> => {
  const response = await axios
    .get<{ data: ActionLog }>('/api/action-logs', {
      params: {
        id: userId,
        startDate: format(startDate, 'yyyy/MM/dd HH:mm:ss'),
        endDate: format(endDate, 'yyyy/MM/dd HH:mm:ss'),
        agencyCode,
        route,
        page,
      },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
